<ng-container *ngIf="breadcrumbs$ | async as breadcrumbs">
  <section
    *ngIf="breadcrumbs.length"
    [class.breadcrumbs-section--with-back-to-search-results]="showBackToSearchResults"
    class="breadcrumbs-section"
  >
    <nav aria-label="Breadcrumbs">
      <ftr-scrollable [contentHasShadow]="false">
        <ul
          class="breadcrumbs"
          data-track-group="Breadcrumbs"
          [class.breadcrumbs__collapsible]="collapseOnSmallDevices && previousPageLink"
          [class.force-collapse]="forceBreadcrumbsCollapse"
        >
          <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
            <ng-container *ngIf="!last; else lastBreadcrumb">
              <li class="breadcrumbs__item">
                <a
                  class="breadcrumbs__link"
                  [class.breadcrumbs__collapsible]="collapseOnSmallDevices"
                  data-track
                  [routerLink]="[breadcrumb.link.url]"
                  [queryParams]="breadcrumb.link.queryParams"
                  >{{ breadcrumb.label }}</a
                >
              </li>
              <li class="breadcrumbs__divider">
                <ftr-icon icon="KeyboardArrowRight" size="Medium" color="GreyLight" align="Bottom"></ftr-icon>
              </li>
            </ng-container>
            <ng-template #lastBreadcrumb>
              <li class="breadcrumbs__item--current">
                {{ breadcrumb.label }}
              </li>
            </ng-template>
          </ng-container>
        </ul>
        <ul *ngIf="collapseOnSmallDevices && previousPageLink" class="breadcrumbs">
          <li class="breadcrumbs__item--back" [class.force-collapse]="forceBreadcrumbsCollapse">
            <a
              class="breadcrumbs__link breadcrumbs__link--back"
              data-track
              [routerLink]="[previousPageLink.url]"
              [queryParams]="getPreviousPageQueryParams(previousPageLink.queryParams)"
              ><ftr-icon icon="KeyboardArrowLeft" size="Medium" color="GreyLight" align="Bottom"> </ftr-icon>
              <span *ngIf="!forceHideBreadcrumbBackText">Back</span>
            </a>
          </li>
        </ul>
      </ftr-scrollable>
    </nav>
  </section>
</ng-container>
